import * as React from 'react'
import { useResultsContext } from '../Spirometry/UseResultsContext';

export interface ResultsGroupHeadingProps {
    title: string,
    resultsCount: number,
}

export const ResultsGroupHeading = (props: ResultsGroupHeadingProps) => {
    return (
        <>
            <tr>
                <th colSpan={props.resultsCount + 3}>
                    {props.title}
                </th>
            </tr>

        </>
    );
}

export const DynamicResultsGroupHeading = (props: ResultsGroupHeadingProps) => {
    const { additionalColumnCount } = useResultsContext();

    return (
        <>
            <tr>
                <th colSpan={props.resultsCount + additionalColumnCount}>
                    {props.title}
                </th>
            </tr>
        </>
    );
}

export default ResultsGroupHeading;
